export const CARRIER_CODE_SUFFIX = '.by-';

export const isErrorCodeOf = (code: string | undefined, baseCode: string) =>
  code === baseCode || !!code?.startsWith(`${baseCode}${CARRIER_CODE_SUFFIX}`);

export const getCarrierFromErrorCode = (
  code: string | undefined
): string | undefined => {
  const suffixIndex = code?.indexOf(CARRIER_CODE_SUFFIX) ?? -1;

  if (!code || suffixIndex < 0) {
    return undefined;
  }

  return code.slice(suffixIndex + CARRIER_CODE_SUFFIX.length) || undefined;
};

export const formatCarrierName = (carrierCode: string): string =>
  carrierCode
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
